<template>
  <div class="contactTitle">
		<span :class="subNavIndex==index?'activeTitle':''" v-for="(item,index) in dataList" :key="index" @click="goItemPage(item,index)">{{item.menuName}}</span>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        dataList:[],
        subNavIndex:0
      }
    },
    created() {
      this.subNavIndex = localStorage.getItem('subNavIndex');
      this.getMenuTree();
	},
    methods: {
      async getMenuTree() {
			const { data: res } = await this.$http.post("/menu/getUserMenuListTree");
			if (!res.success) {
				return this.$message.error(res.message);
			}
      if(res.result && res.result.length>0){
        res.result.map(e=>{
          //语言包todo
          // if(e.menuName == this.$t('tag.txt1') && e.children.length>0){
          if(e.menuName == this.$t('managerPage.txt7') && e.children.length>0){
            this.dataList = e.children
          }
        })
      }
    },
      // 跳转系统设置子页
			goItemPage(item, index) {
        this.subNavIndex = index;
        localStorage.setItem('subNavIndex', index)
				this.$router.replace({
					path: item.menuUrl
				});
			},
    },
  }
</script>

<style>
</style>
